import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCompanyAndFacilityCount } from './userActions';
import { Summary, SummaryResponse, SummaryState } from './types';

const initialState: SummaryState = {
  summary: null,
  loading: false,
  error: null
};

const summarySlice = createSlice({
  name: 'summary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyAndFacilityCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCompanyAndFacilityCount.fulfilled, (state, action: PayloadAction<SummaryResponse>) => {
        state.loading = false;
        state.summary = action.payload.data;
        state.error = null;
      })
      .addCase(fetchCompanyAndFacilityCount.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default summarySlice.reducer;